import * as React from 'react';
import { MobileNavigation } from './MobileNavigation';
import { DesktopNavigation } from './DesktopNavigation';
import { Media, MEDIA_QUERY_MOBILE } from '../../Utils/Responsive';
import { NavigationRoot } from '../../../models';
import './style.css';

export interface NavigationProps {
  items: Array<NavigationRoot>;
  headerItems: Array<NavigationRoot>;
  desktopExpandedItem?: NavigationRoot;
  mobileExpandedItems?: Array<NavigationRoot>;
  expanded: boolean;
  onExpandItem(item: NavigationRoot): void;
  onCollapseItem(item: NavigationRoot): void;
  onToggleMobileItem(item: NavigationRoot): void;
}

export interface NavigationState {
  /* empty */
}

export class Navigation extends React.Component<
  NavigationProps,
  NavigationState
> {
  render() {
    // Use Media component directly since we can only return one root node
    return (
      <Media query={MEDIA_QUERY_MOBILE}>
        {(matches: boolean) =>
          matches ? (
            <MobileNavigation {...this.props} />
          ) : (
            <DesktopNavigation {...this.props} />
          )
        }
      </Media>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/app/components/App/Navigation/index.tsx